<ngx-loading-bar [includeSpinner]='false'></ngx-loading-bar>
<router-outlet></router-outlet>